"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var DetailRow = function (_a) {
    var label = _a.label, value = _a.value, _b = _a.className, className = _b === void 0 ? "" : _b;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-0.5 ".concat(className), children: [(0, jsx_runtime_1.jsx)(react_1.Description, { children: label }), (0, jsx_runtime_1.jsx)("div", { className: "text-sm font-medium text-foreground", children: value })] }));
};
exports.DetailRow = DetailRow;
